<template>
  <sdPageHeader :title="$t('pages.banners.list.title')" />
  <Main>
    <sdCards>
      <a-row :gutter="16">
        <a-col :span="4">
          <label> {{ $t('pages.banners.list.label-state') }} </label>
          <a-select
            :placeholder="$t('common.choose')"
            style="width: 100%"
            v-model:value="filter.status"
            @change="onFilterChanged()"
          >
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('common.1') }}
            </a-select-option>
            <a-select-option :value="0">
              {{ $t('common.0') }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> &nbsp;</label>
          <SearchBoxVue v-model:text="filter.search" @text-changed="onFilterChanged()" />
        </a-col>
        <a-col :span="2">
          <label> &nbsp;</label>
          <sdButton size="default" :outlined="true" type="success" style="width: 100%" @click="getTable">
            {{ $t('common.filter') }}
          </sdButton>
        </a-col>
        <a-col :span="2">
            <router-link :to="'/banners/create'">
          <label> &nbsp;</label>
          <sdButton size="default" :outlined="true" type="primary" style="width: 100%" >
            {{ $t('pages.banners.list.create-banner') }}
          </sdButton>
            </router-link>
        </a-col>
      </a-row>
      <br />

      <div v-if="isLoading" class="spin">
        <a-spin />
      </div>
      <div v-else>
        <a-table
          class="table-responsive"
          :columns="columns"
          :data-source="tableData"
          :pagination="{
            pageSize: this.filter.pageSize,
            showSizeChanger: true,
            total: this.filter.total,
            current: this.filter.current,
          }"
          @change="onTableChange"
          size="small"
        >
          <template #image="{ record }">
            <a-space>
              <div class="record-img align-center-v">
                <img :src="record.image" style="height: 40px; max-width: 150px" />
              </div>
            </a-space>
          </template>

          <template #status="{ record }">
            <a-space align="baseline">
              <a-switch v-model:checked="record.status" @click="onToggleChange(record)" />
              <p>{{ record.status ? $t('common.1') : $t('common.0') }}</p>
            </a-space>
          </template>

          <template #action="{ record }">
            <a-space>
              <a-tooltip placement="top">
                <template #title>
                  <span>{{ $t('common.remove') }}</span>
                </template>
                <a-button type="primary" @click="deleteRecord(record.key)">
                  <template #icon> <sdFeatherIcons type="trash-2" style="color: white" /> </template>
                </a-button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template #title>
                  <span>{{ $t('common.edit') }}</span>
                </template>
                <router-link :to="'/banners/detail/' + record.key">
                  <a-button type="primary">
                    <template #icon> <sdFeatherIcons type="edit" style="color: white" /> </template>
                  </a-button>
                </router-link>
              </a-tooltip>
            </a-space>
          </template>
        </a-table>
      </div>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import SearchBoxVue from '@/components/search/SearchBox.vue';

export default {
  name: 'BannerList',
  components: {
    Main,
    SearchBoxVue,
  },
  data() {
    return {
      isLoading: true,
      isFilterNew: false,
      filter: {
        current: 1,
        pageSize: 10,
        total: null,
        status: null,
        search: ''
      },
      tableData: [],
      columns: [
        {
          title: this.$t('pages.banners.list.table-image'),
          dataIndex: 'image',
          key: 'image',
          slots: { customRender: 'image' },
        },
        {
          title: this.$t('pages.banners.list.table-title'),
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: this.$t('pages.banners.list.table-rank'),
          dataIndex: 'rank',
          key: 'rank',
        },
        {
          title: this.$t('pages.banners.list.table-status'),
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: this.$t('pages.banners.list.table-action'),
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    onFilterChanged() {
      this.isFilterNew = true;
      this.filter.current = 1;
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.getTable();
      this.isFilterNew = false;
    },
    getTable() {
      this.isLoading = true;
      this.$appAxios.post(this.$endpoints.banners_get, this.filter).then(response => {
        if (response.data.status === true) {
          var tableRecords = response.data.data.tableData;
          this.filter.total = response.data.data.total;
          this.tableData = [];
          var _this = this;
          tableRecords.forEach(function(item, index) {
            _this.tableData.push({
              key: item.id,
              image: item.image,
              title: item.title,
              rank: item.rank,
              status: item.active ? true : false,
            });
          });
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
        this.isLoading = false;
      });
    },
    deleteRecord(id) {
      if (!confirm(this.$t('common.confirm-delete'))) {
        return;
      }
      this.$appAxios.post(this.$endpoints.banners_delete, { id: id }).then(response => {
        if (response.data.status === true) {
          this.getTable();
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    onToggleChange(record) {
      this.updateRecord(record);
    },
    updateRecord(record) {
      var form = {
        id: record.key,
        status: record.status ? 1 : 0,
      };
      this.$appAxios.post(this.$endpoints.banners_update, form).then(response => {
        if (response.data.status === true) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
  },
};
</script>
